import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "../../SportsTravel/SportsMidBanner/SportsMidBanner.css";
import "../../BusinessTravel/BTmidBanner/BTmidBanner.css";
import "./CorporateTravelersMidBanner.css";

const CorporateTravelersMidBanner = () => {
  return (
    <>
      <div className="container sports-mid-section">
        <div className="row px-md-4">
          <div className="col-md-12">
            <h1 className="headings">
              <span>Flexible </span>Travel Solutions to Fit Your Needs
            </h1>
            <p className="grotesk-headings sports-mid-banner-p">
              At Blueberry Travels, we understand that every business trip is
              more than just a journey—it’s a mission to achieve your company’s
              goals. Our corporate travel management services are designed to
              simplify every aspect of your travel program. From easy bookings
              to securing subordination with company policies, we take care of
              everything. Our experts examine your team’s travel requirements
              and design programs that enhance productivity, save expenses, and
              ensure hassle-free travel ventures for your employees.
            </p>
          </div>
        </div>
      </div>

      <div className="container why-bbt">
        <div className="row">
          <div className="col-md-12">
            <h1 className="headings text-center fs8 ">
              <span>Experience </span>the Future of Business Travel
            </h1>
          </div>
        </div>
      </div>
      <div className="bbt-img details-section corporateees">
        <div className="container mt-md-5">
          <div className="row">
            <div className="col-md-6 col-lg-3 col-6 mt-md-3 mb-lg-5 d-flex justify-content-center padding">
              <div className="box1 office">
                <div className="d-flex flex-column pb-4 mt-xxl-5 mt-md-4 pt-5">
                  <h4 className="headings text-center first-section position-relative zindex mt-3 pt-2  mt-md-3 mt-xxl-4">
                    Time-Saving Solutions
                  </h4>
                  <p className="text-center mt-2">
                    Well-organized booking processes save time and reduce manual
                    effort.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 col-6 mt-md-3 mb-lg-5 d-flex justify-content-center padding">
              <div className="box1 phone">
                <div className="d-flex flex-column pb-4  mt-xxl-5 mt-md-4 pt-5">
                  <h4 className="headings text-center second-section position-relative zindex mt-3 pt-2  mt-md-3 mt-xxl-4">
                    Cost Efficiency
                  </h4>
                  <p className="text-center mt-2">
                    Our smart travel strategies help you stay under budget
                    without compromising quality.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 col-6 mt-md-3 mb-lg-5 d-flex justify-content-center mt-md-4  padding">
              <div className="box1 email">
                <div className="d-flex flex-column mt-xxl-5 mt-md-4 pt-5 pb-4">
                  <h4 className="headings text-center third-section position-relative zindex mt-3 pt-2  mt-md-3 mt-xxl-4">
                    Easy Compliance
                  </h4>
                  <p className="text-center mt-1">
                    We arrange travel programs with your organization’s policies
                    and guidelines.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 col-6 mt-md-3 mb-lg-5 d-flex justify-content-center mt-md-4 padding">
              <div className="box1 website">
                <div className="d-flex flex-column mt-xxl-5 mt-md-4 pt-5 pb-4">
                  <h4 className="headings text-center fourth-section position-relative zindex mt-3 pt-2  mt-md-3 mt-xxl-4">
                    Seamless Support
                  </h4>
                  <p className="text-center mt-1">
                    A trustworthy support crew to assist travelers anytime,
                    anywhere.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="last-banner traveler-mid-banner">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 text-white">
              <h1 className="headings">
                <span className="last-banner-span">Let </span>Our Results Speak
                for Themselves
              </h1>
              <p>Contact Blueberry Travels Today</p>
              <div className="carouselCaption">
                <a href="/contact">
                  <button className="btn bg-transparent text-white mt-md-3 ps-5 pt-3 text-uppercase pb-3 pe-5 grotesk-headings fw-bold">
                    Contact Us
                  </button>
                </a>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="traveler-banner-img bt-last-banner">
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/images/ctmidbanner.png"
                  alt="Travel Banner"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CorporateTravelersMidBanner;
